import { TableHeadCell } from "@shared/primitive-components"

export const vehicleHeaderProps = {
  header: `Vehicle`,
  tooltipContent: `The vehicle associated with this trip.`,
}

export const VehicleHeader = () => <TableHeadCell {...vehicleHeaderProps} />
